import React from 'react';
import {
  CandidateStories,
  PromptGroup,
  RecordDocuments,
} from 'types/candidateStories';
import { SearchRecord } from 'types/record';
import PromptSummaryGeneralSection from './PromptSummaryGeneralSection';
import PromptSummaryRecordSection from './PromptSummaryRecordSection';

type Props = {
  candidateStories: CandidateStories;
  selectedRecords: SearchRecord[];
  promptGroups: PromptGroup[];
};

const CandidateStoryPromptSummary = ({
  candidateStories,
  selectedRecords,
  promptGroups,
}: Props) => {
  const summaryPromptItems = candidateStories.promptGroup?.content || {};
  const { general = {}, ...recordResponses } = summaryPromptItems;
  const generalDocuments = candidateStories.promptGroup?.general || {};
  const recordDocuments: RecordDocuments = {};

  Object.keys(candidateStories.promptGroup || {}).forEach(key => {
    if (key !== 'content' && key !== 'general') {
      recordDocuments[key] = candidateStories.promptGroup[key];
    }
  });

  const showSeparator =
    Object.keys(recordResponses).length > 0 ||
    Object.keys(recordDocuments).length > 0;

  return (
    <div data-testid='candidate-story-prompt-summary'>
      <PromptSummaryGeneralSection
        generalResponses={general}
        generalDocuments={generalDocuments}
        promptGroups={promptGroups}
      />
      {showSeparator && <hr className='mt-3 mb-4' />}
      <PromptSummaryRecordSection
        recordResponses={recordResponses}
        selectedRecords={selectedRecords}
        promptGroups={promptGroups}
        recordDocuments={recordDocuments}
      />
    </div>
  );
};

export default CandidateStoryPromptSummary;
